import { render, staticRenderFns } from "./TableColumn.vue?vue&type=template&id=68506d5f&scoped=true&"
import script from "./TableColumn.vue?vue&type=script&lang=js&"
export * from "./TableColumn.vue?vue&type=script&lang=js&"
import style0 from "./TableColumn.vue?vue&type=style&index=0&id=68506d5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68506d5f",
  null
  
)

export default component.exports